import { Banner } from "components/IssuesBanner/Banner";
import { useUser } from "routes/dataroutes/UserData";

export default function AccountPendingRemovalBanner() {
  const user = useUser();

  const isPendingRemoval = user?.isPendingDeletion ?? false;

  return (
    <>
      {isPendingRemoval && (
        <Banner
        title="Account status: pending deletion. If you want to stop the account deletion process please reach out to [support@scraperapi.com|contact_support_email]."
        dismissible={ true }
        severity="warning"
      />
      )}
    </>
  );
}